module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "windows_start_sound.7e384957.wav" + "?" + Date.now();